/*! dependencies: cash, jquery-throttle-debounce, general */

instant.header = {
  settings: cash.extend({

  }, instant.settings && instant.settings.header ? instant.settings.header : {}),
  initialized: false,
  init: function () {
    if (!instant.header.initialized) {
      instant.header.initialized = true;

      var header = cash('header');

      if (header.length) {
          instant.header.bindEvents();
          instant.header.initBurgerMenuButtonAttributes();
      }
    }
  },
  bindEvents: function () {
    cash('body').on('click', '#hamburger', function () { instant.header.toggleBurgerMenu(); });
    cash('body').on('click', '#hamburger-menu .dropdown-trigger', instant.header.toggleBurgerMenuItem);
  },
    toggleBurgerMenu: function () {
    const hamburger = cash('#hamburger');
    const hamburgerMenu = cash('#hamburger-menu');
    const screenReaderText = hamburger.find('span');
    cash('header').toggleClass('burger-open');
    cash('body').toggleClass('overflow-y-hidden');

    const hamburgerExpandedValue = hamburger.attr('aria-expanded');

    if (hamburgerExpandedValue === 'false') {
        hamburger.attr('aria-expanded', 'true');
        hamburgerMenu.attr('aria-expanded', 'true');
        screenReaderText.text('Menu (Åben)');
    }
    else {
        hamburger.attr('aria-expanded', 'false');
        hamburgerMenu.attr('aria-expanded', 'false');
        screenReaderText.text('Menu (Lukket)');
    }
  },
  toggleBurgerMenuItem: function () {
    var wrapper = cash(this).closest('li');

    wrapper.toggleClass('active');
    wrapper.find('ul').toggleClass('hidden');
    },
    initBurgerMenuButtonAttributes: function () {
        const hamburger = cash('#hamburger');
        const hamburgerMenu = cash('#hamburger-menu');
        const screenReaderText = hamburger.find('span');
        hamburger.attr('aria-controls', 'hamburger-menu');
        hamburger.attr('aria-expanded', 'false');
        hamburgerMenu.attr('aria-expanded', 'false');
        screenReaderText.text('Menu (Lukket)');
    }
};